import { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon } from '@fluentui/react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import NoDataLayer from '../../../../../Common/NoDataLayer';

class ELEMENT_BOOK_SUMMARY extends React.Component {
  constructor(props) {
    super(props);

    this.fakeData = {items: {
      isSent: 0,
      isPendingWaiting: 0,
      isExpiredWaiting: 0,
    }}
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_BoardStructure: PropTypes.object,
    inputParam_Container: PropTypes.object,
    inputParam_ComponentContent: PropTypes.object,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_BoardStructure: null,
    inputParam_Container: null,
    inputParam_ComponentContent: null,
    inputParam_UseFake: false
  };

  renderContent(data) {
    return  <Row className='mx-2 d-flex h-100 align-items-center' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
              <Col className='mx-2 border'>
                <Row className='border' style={{backgroundColor: "#efefef"}}>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-communications')}</Col>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-sent')}</Col>
                </Row>
                <Row>
                  <Col className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{ data !==null && data.items.length > 0 ? data.items.filter(x => x.isSent === true).length : '--' }</Col>
                </Row>
              </Col>
              <Col className='mx-2 border'>
                <Row className='border' style={{backgroundColor: "#efefef"}}>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-responses')}</Col>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-pendingbuyer')}</Col>
                </Row>
                <Row>
                  <Col className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{ data !==null && data.items.length > 0 ? data.items.filter(x => x.isPendingWaiting === true).length : "--" }</Col>
                </Row>
              </Col>
              <Col className='mx-2 border'>
                <Row className='border' style={{backgroundColor: "#efefef"}}>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-responses')}</Col>
                  <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{t('data-lang-lbl-pendingeecc')}</Col>
                </Row>
                <Row>
                  <Col className='text-center font-weight-bold' style={{fontSize: "16px", fontWeight: "bold"}}>{ data !==null && data.items.length > 0 ? data.items.filter(x => x.isExpiredWaiting === true).length : '--' }</Col>
                </Row>
              </Col>
            </Row>
  }

  render() {
    return (
      <>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100'>
          {
            !this.props.inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="d-flex justify-content-between">
                <b>{ (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-booksumary')}</b>
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                      inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                      inputParam_Container={this.props.inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='px-1 py-0 h-100'>
            {this.renderContent(this.props.inputParam_ComponentContent)}
          </Card.Body>
        </Card>
      }
      {this.props.inputParam_UseFake && this.renderContent(this.fakeData)}
      </>
    );
  }
}

export default ELEMENT_BOOK_SUMMARY;